import { z } from "zod";
import { responseSchema } from "../http.js";
import { emailSchema, phoneSchema, publicUserSchema } from "./auth.js";
import { OPERATING_COUNTRIES } from "./country.js";
import { orderSchema } from "./order.js";
const nameSchema = z.string().trim().min(1, "Escribe el nombre").max(80, "Muy largo");
/**
 * ═══════════════════════════════════════════════════════════
 * Registros — el alta de un socio desde el admin (Anahí, 14-sep-2026)
 *
 * «Un wizard: productos, membresías y paquetes (uno o más de cada);
 * después nombre, correo, país y a quién se le asigna. Con eso se cierra
 * el registro: se agrega al sistema y se le manda al correo la
 * invitación para que ponga su contraseña, con indicaciones.»
 *
 * Lo que hace el servidor, en orden y en una sola petición:
 *   1. Crea la cuenta (sin contraseña: la pondrá con el enlace).
 *   2. La cuelga de la red bajo el patrocinador (o de la raíz).
 *   3. Crea la orden con lo elegido, a precio de socio, y —si el admin
 *      lo marca— la VALIDA en el acto: puntos, membresía anual, reloj
 *      y comisiones de la línea, igual que cualquier orden.
 *   4. Manda la invitación: un enlace de 7 días para crear contraseña.
 * ═══════════════════════════════════════════════════════════
 */
export const REGISTRATION_ITEM_KINDS = ["product", "membership", "package"];
export const registrationItemKindSchema = z.enum(REGISTRATION_ITEM_KINDS);
export const registrationItemSchema = z.object({
    kind: registrationItemKindSchema,
    id: z.string().trim().min(1),
    quantity: z.number().int().min(1).max(99),
});
export const registrationRequestSchema = z.object({
    firstName: nameSchema,
    lastName: nameSchema,
    email: emailSchema,
    phone: phoneSchema.optional(),
    country: z.enum(OPERATING_COUNTRIES),
    /** El enlace de invitación o el código del patrocinador. `null` = raíz. */
    sponsorCode: z.string().trim().max(300).nullable(),
    items: z.array(registrationItemSchema).min(1, "Elige al menos un producto, membresía o paquete").max(60),
    /** Marcar la orden como pagada en el acto (el admin ya cobró). */
    validateNow: z.boolean().default(true),
});
export const registrationResultSchema = z.object({
    user: publicUserSchema,
    order: orderSchema,
    /** Si la orden quedó validada (puntos, membresía y comisiones ya corrieron). */
    validated: z.boolean(),
    /** Si el correo de invitación salió de verdad (o solo quedó en el log). */
    invitationSent: z.boolean(),
    sponsorName: z.string().nullable(),
});
export const registrationResponseSchema = responseSchema(z.object({ result: registrationResultSchema }));
export const REGISTRATION_ROUTES = {
    adminCreate: "/api/admin/registrations",
};
//# sourceMappingURL=registration.js.map